import { createFileRoute } from "@tanstack/react-router";
import { faqJsonLd, jsonLdScript, pageHead } from "@/components/site/seo-copy";
import AcademyView from "@/components/cl/views/AcademyView";

const faqs = [
  { q: "Do I need any experience?", a: "No. The Academy is built for complete beginners." },
  {
    q: "How much does the Academy cost?",
    a: "We go through everything on your free career call, including the investment, once we both know the Academy is right for you.",
  },
  {
    q: "What roles will I be able to apply for?",
    a: "Entry-level roles in recruitment, appointment setting, lead generation and fundraising, with routes up into closing, account management and team leading.",
  },
  {
    q: "Do I have to do the Academy to use Closdd?",
    a: "No. The board is free and open to every salesperson. The Academy is for people who want to be trained first.",
  },
  { q: "Is the training live or recorded?", a: "Live, with role-plays and personal feedback." },
  {
    q: "Can I do it around a job?",
    a: "Ask us on your call and we will talk through the schedule.",
  },
];

export const Route = createFileRoute("/academy")({
  head: () => ({
    ...pageHead("/academy"),
    scripts: [jsonLdScript(faqJsonLd(faqs))],
  }),
  component: AcademyView,
});
